export default __webpack_public_path__ + "static/media/RegisterBackground.1c63020a.JPG";